"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 24,
      padding: '',
      borderRadius: 4,
      whiteSpace: 'nowrap',
      background: function background(_ref) {
        var color = _ref.color;
        if (!color) {
          return 'none';
        }
        if (!theme.palette.hasOwnProperty(color)) {
          throw new Error("Status color \"".concat(color, "\" not supported in status component"));
        }
        return (0, _styles.alpha)(theme.palette[color].main, 0.16);
      },
      color: function color(_ref2) {
        var _color = _ref2.color;
        if (!_color) {
          return 'none';
        }
        if (!theme.palette.hasOwnProperty(_color)) {
          throw new Error("Status color \"".concat(_color, "\" not supported in status component"));
        }
        return theme.palette[_color].main;
      }
    },
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 8,
      paddingRight: 8,
      whiteSpace: 'nowrap',
      fontWeight: 500
    }
  };
}, {
  name: 'GgStatus'
});
var Status = function Status(_ref3) {
  var color = _ref3.color,
    children = _ref3.children;
  var classes = useStyles({
    color: color
  });
  if (!children) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _clsx["default"])(classes.root),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _clsx["default"])(classes.label),
      children: children
    })
  });
};
var _default = exports["default"] = Status;